import { PollResults } from '@core/poll';
import { Accordion, Polls } from '@core/ui';
import { ActivePollStatus, closePoll, hidePoll, startPoll, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PollQuestion } from '../../atoms/PollQuestion';
import { PollToggleButton } from '../../atoms/PollToggleButton';

export const PollsContainer = () => {
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    const dispatch = useAppDispatch();
    const polls = useAppSelector((state) => state.liveWebinar.polls);
    const activePoll = useAppSelector((state) => state.liveWebinar.activePoll);
    const activePollStatus = useAppSelector((state) => state.liveWebinar.activePollStatus);

    return (
        <div className="w-full flex-1 overflow-auto bg-comp-grad">
            {polls?.length === 0 && (
                <div
                    className="h-full w-full bg-stripes bg-[length:16px_16px] flex flex-col justify-center items-center text-center text-black text-lg p-4"
                    data-testid="PollsEmpty"
                >
                    <div className="bg-white/85 rounded-xl p-8">
                        <Polls classNames="size-20 stroke-gray-400 mx-auto" />
                        {t('Player.NoPolls')}
                    </div>
                </div>
            )}
            {polls.map((poll, index) => (
                <div key={poll.pollId} className="bg-white border-2 border-primary rounded-md mt-1 mb-2 mx-2">
                    <Accordion
                        title={<PollQuestion classNames="mr-2" question={poll.question} />}
                        index={index}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        content={
                            <div className="text-sm font-bold px-2 pt-4">
                                <div className="flex gap-2">
                                    {!activePoll && (
                                        <PollToggleButton onClick={() => dispatch(startPoll(poll.pollId))}>
                                            {t('Broadcaster.Poll.Button.Start')}
                                        </PollToggleButton>
                                    )}

                                    {poll?.pollId === activePoll?.pollId && activePollStatus === ActivePollStatus.Active && poll?.publicResults && (
                                        <PollToggleButton onClick={() => dispatch(closePoll())}>{t('Broadcaster.Poll.Button.Close')}</PollToggleButton>
                                    )}
                                    {poll?.pollId === activePoll?.pollId && activePollStatus === ActivePollStatus.Closed && poll?.publicResults && (
                                        <PollToggleButton onClick={() => dispatch(hidePoll())}>{t('Broadcaster.Poll.Button.HideResults')}</PollToggleButton>
                                    )}
                                    {!poll?.publicResults && poll?.pollId === activePoll?.pollId && (
                                        <PollToggleButton onClick={() => dispatch(hidePoll())}>{t('Broadcaster.Poll.Button.Close')}</PollToggleButton>
                                    )}
                                </div>
                                <div>
                                    {!poll?.publicResults && <p className="bg-info rounded-lg mt-2 p-2">{t('Broadcaster.Poll.NoPublicResults')}</p>}
                                    <PollQuestion classNames="text-lg pt-2 px-2" question={poll.question} />
                                    <PollResults poll={poll} />
                                    {poll?.applyWeighting && <p className="bg-info rounded-lg mb-2 p-2">{t('Broadcaster.Poll.WeightingApplied')}</p>}
                                </div>
                            </div>
                        }
                    />
                </div>
            ))}
        </div>
    );
};
